import { render } from "./SectionNine.vue?vue&type=template&id=46a22dc0&scoped=true"
import script from "./SectionNine.vue?vue&type=script&lang=js"
export * from "./SectionNine.vue?vue&type=script&lang=js"

import "./SectionNine.vue?vue&type=style&index=0&id=46a22dc0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a22dc0"]])

export default __exports__